import React from 'react'
import {
  textWithHTML,
  percentage,
  numberMoney,
  textToNumber,
} from 'Data/format.js'
import { useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let ach_fee_percent = useDataValue({
    context: 'reusable_method',
    path: 'provider_location_account.ach_fee_percent',
    viewPath: props.viewPath,
  })

  let amount = textToNumber(props.amount)

  return (
    <View
      text={textWithHTML(
        `A <b>fee of ${
          amount
            ? `${numberMoney((amount * ach_fee_percent) / 100)} (${percentage(ach_fee_percent)})`
            : percentage(ach_fee_percent)
        }</b> will be added.`
      )}
      {...props}
    />
  )
}
